import React from 'react';
import { Accordion } from 'react-bootstrap';
import HeroSection from 'src/components/global/HeroSection';
import JoinNowSection from 'src/components/global/JoinNowSection';

const BecomeAnAfilliateView = () => {
  return (
    <>
      <HeroSection
        pageTitle={
          <>
            There Is Another Way To
            <br /> Make Money With <br />
            <span className="text-gradient fw-700">Gunbot:</span>
            <br /> Become An <span className="text-gradient fw-700">Affiliate</span>.
          </>
        }
        uris={['Shops', 'Become An Affiliate']}
      />

      <div className="page-content">
        <section style={{ backgroundColor: 'rgba(255, 215, 37, 0.02)' }}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-8">
                <Accordion defaultActiveKey="0">
                  <Accordion.Item
                    eventKey="0"
                    className="mb-4 bg-transparent border rounded border-dark overflow-hidden"
                  >
                    <Accordion.Header>10% commissions for each sale</Accordion.Header>
                    <Accordion.Body className="text-body">
                      Receive 10% for each sale, in crypto or paypal
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item
                    eventKey="1"
                    className="mb-4 bg-transparent border rounded border-dark overflow-hidden"
                  >
                    <Accordion.Header>Automated process: just share your link</Accordion.Header>
                    <Accordion.Body className="text-body">
                      The process is fully automated: you and your customer will receive an email at orders creation and
                      order payment. Your customer gets automatic access to Gunbot School.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item
                    eventKey="2"
                    className="mb-4 bg-transparent border rounded border-dark overflow-hidden"
                  >
                    <Accordion.Header>Monthly Payments: in Crypto</Accordion.Header>
                    <Accordion.Body className="text-body">
                      Access resellers room, with monthly stats and reports for your payments in Crypto
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3" className="bg-transparent border rounded border-dark overflow-hidden">
                    <Accordion.Header>Always new promo and discounts for your customers</Accordion.Header>
                    <Accordion.Body className="text-body">
                      A very active marketing team with new promo and discounts for your customers to be always on top
                      of latest technology
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>
        </section>

        <JoinNowSection
          title="Join our resellers team"
          description="Don't Miss Out On Yet Another Way To Make Money With Gunbot"
          link="https://docs.google.com/forms/d/e/1FAIpQLSfQNf46lkXeZ8LleJwLcOHNH1xGdPjCYKnySyXnN0aiMZQxgQ/viewform?usp=pp_url"
        />
      </div>
    </>
  );
};

export default BecomeAnAfilliateView;
